import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class RelatorioAnualTransparencia extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"RelatorioAnualTransparencia"} page={'RelatorioAnualTransparencia'}></InfoComponent>

					{/* Content page */}
					<div className="_the-content page-planos pb-10 mb-4">
						<div className='container'>
							<div className="row justify-content-center">

								<ErrorBoundary><DocumentLink  fileImg={'../../assets/img/organograma/img-org.png'} url={'ObterTac'} /></ErrorBoundary>



							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RelatorioAnualTransparencia;